import { DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import { TableItemContainer, TableItemTextView, TableItemView } from "components/shared";
import { UIAmountInput, UICheckbox } from "components/ui";
import React from "react";
import { SVGAsset } from "res";

import "./styles.css";

/**
 * @function ACHTransfersToTableRow
 * @param {STRING} nickname - Sets the ACH account nickname text.  
 * @param {STRING} notify - Sets the ACH notify text.
 * @param {STRING} uid - Sets the ACH unique identifier text.
 * @param {STRING} accountNumber - Sets the ACH account number text. 
 * @param {STRING} accountType - Sets the ACH account type text.
 * @return {React.Component}
 * @exported true
 * @description - This is the table row used for the One Time ACH To table view.
 */
export default function ACHTransfersToTableRow(props) {
    const achToParticipant = props.achToParticipant ?? {};
    const participant = achToParticipant.participant ?? {};
    const participantId = achToParticipant.id ?? {};
    const onACHToParticipantChange = props.onACHToParticipantChange ?? (() => {});
    const onACHToParticipantDelete = props.onACHToParticipantDelete ?? (() => {});
    const showHoldPrenoteDistributionColumns = props.showHoldPrenoteDistributionColumns ?? false;
    const nickname = props.nickname ?? "[nickname]";
    const notify = props.notify ?? "[notify]";
    const uid = props.uid ?? "[uid]";
    const accountNumber = props.accountNumber ?? "[accountNumber]";
    const accountType = props.accountType ?? "[accountType]";
    const addenda = props.addenda ?? "[0]";
    const nicknameDataPoint = props.dataPoint ? { dataPoint: `${ props.dataPoint }_nickname` } : {};
    const notifyDataPoint = props.dataPoint ? { dataPoint: `${ props.dataPoint }_notify` } : {};
    const uidDataPoint = props.dataPoint ? { dataPoint: `${ props.dataPoint }_uid` } : {};
    const accountNumberDataPoint = props.dataPoint ? { dataPoint: `${ props.dataPoint }_account_number` } : {};
    const accountTypeDataPoint = props.dataPoint ? { dataPoint: `${ props.dataPoint }_account_type` } : {};
    const addendaDataPoint = props.dataPoint ? { dataPoint: `${ props.dataPoint }_addenda` } : {};
    const editIconDataPoint = props.dataPoint ? { "data-point": `${ props.dataPoint }_edit_icon` } : {};
    const deleteIconDataPoint = props.dataPoint ? { "data-point": `${ props.dataPoint }_delete_icon` } : {};

    const amountDataPoint = props.dataPoint ? { dataPoint: `${ props.dataPoint }_amount` } : {};
    
    const isCheckingAcct = participant.accountType === "Checking" ? true: false;

    return (
        <TableItemContainer>
            <TableItemTextView text={ participant.nickname } { ...nicknameDataPoint } />
            <TableItemTextView className="notify-col" text={ achToParticipant.notify } { ...notifyDataPoint } />
            <TableItemTextView className="uid-col" text={ participant.uniqueID } { ...uidDataPoint } />
            <TableItemTextView className="account-number-col" text={ participant.number } { ...accountNumberDataPoint } />
            <TableItemTextView className="account-type-col" text={ participant.accountType } { ...accountTypeDataPoint } />
            { showHoldPrenoteDistributionColumns && 
            <>
                <TableItemView className="hold-col">
                    {isCheckingAcct && <UICheckbox label="" onChange={ onACHToParticipantChange("hold", achToParticipant) } dataPoint={`ACH_To_Participant_Hold_${participantId}`} /> }
                </TableItemView>
                <TableItemView className="prenote-col">
                    <UICheckbox label="" onChange={ onACHToParticipantChange("prenote", achToParticipant) }  dataPoint={`ACH_To_Participant_Prenote_${participantId}`}/> 
                </TableItemView>
            </>
            }
            <TableItemView className="amount-col">
                <UIAmountInput value={ achToParticipant.amount.amount } { ...amountDataPoint } onChange={ onACHToParticipantChange("amount", achToParticipant) } />
            </TableItemView>
            { showHoldPrenoteDistributionColumns && 
            <TableItemTextView className="distributions-col" text={ `${ achToParticipant.numberOfDistributions } Distributions` } />
            }
            <TableItemView className="addenda-col text-center">
                <DisabledPrompt>
                    <Link { ...addendaDataPoint }>{ achToParticipant.addenda } Addenda</Link>
                </DisabledPrompt>
            </TableItemView>
            <TableItemView className="actions-col text-center">
                <DisabledPrompt>
                   {isCheckingAcct && <SVGAsset id="EditIcon" { ...editIconDataPoint } className="edit-icon clickable"/>}
                </DisabledPrompt>
                <a onClick={ onACHToParticipantDelete(achToParticipant) }>
                    <SVGAsset id="TrashcanXIcon" { ...deleteIconDataPoint } className="trash-can-x-icon clickable"/>
                </a>
            </TableItemView>
        </TableItemContainer>
    )
}
